"use client";
import React, { useState ,useEffect} from "react";
import StatsCard from "../../../../components/stats-card";
import CustomerDetails from "../../../global/view/customer-detailsForm.jsx";
import styles from "../css/toFollows.module.css";
import totalStyles from "../css/totalOutstanding.module.css";
import overlayStyles from "../../../../css/components/overlaymodal-animations.module.css";
import FilterTabs from "../../../../components/universal-filter-tabs";
import Status from "../../../../components/Status";
import FormInput from "../../../../components/FormInput";
import Button from "../../../../components/Button";
import Pagination from "../../../../components/Pagination";
import PharmacistSignatureModal from "../../../global/view/PharmacistSignatureModal.jsx";
import { useNavigate } from "react-router-dom";
import overlayTfStyles from "../css/overlayToFollows.module.css";
import ToFollowsOverlayModal from "./ToFollowsOverlayModal.jsx";
import { fetchProfilesWithOutstandingToFollows, fetchTotalOutstandingToFollows } from "../../../../api/toFollows/toFollowsApi.js";
import { useAuth } from "../../../../context/AuthContext";

export default function ToFollowsList() {
  const navigate = useNavigate();
  const [showOverlay, setShowOverlay] = useState(false);
  const [showSignature, setShowSignature] = useState(false);
  const [showCompleted, setShowCompleted] = useState(false);
  const [selectedProfileNo, setSelectedProfileNo] = useState(null);
  const [selectedPatient, setSelectedPatient] = useState(null); 
  const [search, setSearch] = useState("");
  const [active, setActive] = useState("Ready");
  const [page, setPage] = useState(1);
  const [profilesWithOutstanding, setProfilesWithOutstanding] = useState(new Set());
  const [profilesLoaded, setProfilesLoaded] = useState(false);
  const { user } = useAuth();
  const [counts, setCounts] = useState({ total: 0, ready: 0 });

  const reloadCounts = async () => {
    try {
      const data = await fetchTotalOutstandingToFollows(null, user?.branchcode);
      const ready = (data || []).filter(p => (p.status || "").toLowerCase().includes("ready")).length;
      const pending = (data || []).filter(p => (p.status || "").toLowerCase().includes("pending")).length;
      setCounts({ total: ready + pending, ready });
    } catch (e) {
      setCounts({ total: 0, ready: 0 });
    }
  };

  useEffect(() => {
    let isMounted = true;
    (async () => {
      try {
        const profileNos = await fetchProfilesWithOutstandingToFollows();
        if (isMounted) {
          const setVals = new Set((profileNos || []).map(Number));
          setProfilesWithOutstanding(setVals);
          setProfilesLoaded(true);
        }
      } catch (err) {
        console.error("Failed to load profiles with outstanding to-follows:", err);
        if (isMounted) {
          setProfilesLoaded(true);
        }
      }
    })();
    return () => {
      isMounted = false;
    };
  }, []);

  useEffect(() => {
    let isMounted = true;
    (async () => {
      try {
        const data = await fetchTotalOutstandingToFollows(null, user?.branchcode);
        if (isMounted) {
          const ready = (data || []).filter(p => (p.status || "").toLowerCase().includes("ready")).length;
          const pending = (data || []).filter(p => (p.status || "").toLowerCase().includes("pending")).length;
          setCounts({ total: ready + pending, ready });
        }
      } catch (e) {
        if (isMounted) {
          setCounts({ total: 0, ready: 0 });
        }
      }
    })();
    return () => { isMounted = false; };
  }, [user?.branchcode]);

  const openOverlay = (profileNo) => {
    setSelectedProfileNo(profileNo || null);
    setShowOverlay(true);
  };
  const closeOverlay = () => {
    setShowOverlay(false);
    setSelectedProfileNo(null);
  };
  const handleToFollowDispensed = async () => {
    await reloadCounts();
  };
  const header = (
    <div className={styles.headerCards}>
      <div className={styles.statCard}>
        <StatsCard className={styles.statsCompactCard} title="Total To Follows" value={counts.total} icon="hourglass" onClick={() => navigate('/customer/dispensary/to-follows/total-outstanding')} />
      </div>
      <div className={styles.statCard}>
        <StatsCard className={styles.statsCompactCard} title="Ready For Pick Up" value={counts.ready} icon="calendar-check-2" />
      </div>
    </div>
  );
  const buttons = ["Ready", "Pending", "All"]; // retained for potential future use

  const handleCompleteFollowUp = () => {
    setShowSignature(true);
  };

  const handleSignatureNext = () => {
    setShowSignature(false);
    setShowCompleted(true);
  };

  const CompletedPopup = () => (
    !showCompleted ? null : (
      <div className={`${overlayStyles.modalOverlay} ${overlayStyles.show}`}>
        <div className={`${overlayStyles.modalContent} ${overlayStyles.stepEnter} ${overlayTfStyles.completedModal}`}>
          <button className={overlayStyles.closeButton} onClick={() => { setShowCompleted(false); closeOverlay(); }} aria-label="Close completed">×</button>
          <div className={overlayTfStyles.completedIcon}>✔</div>
          <h2 className={overlayTfStyles.completedTitle}>Completed</h2>
          <Button variant="primary" onClick={() => { setShowCompleted(false); closeOverlay(); }}>Done</Button>
        </div>
      </div>
    )
  );

  return (
    <div className={styles.pageWrap}>
      <CustomerDetails
        showTitle={false}
        actionButtonLabel="View"
        onActionClick={openOverlay}
        showAddPatientButton={false}
        headerContent={header}
      />
      {/* Spacer to keep pagination above footer */}
      <div className={styles.bottomSpacer} />
      {showOverlay && (
        <ToFollowsOverlayModal
          isOpen={showOverlay}
          onClose={closeOverlay}
          profileNo={selectedProfileNo}
          onDispensed={handleToFollowDispensed}
        />
      )}
      <PharmacistSignatureModal
        isOpen={showSignature}
        onClose={() => setShowSignature(false)}
        onNext={handleSignatureNext}
        openPreviewOnNext={false}
        nextLabel="Confirm"
        title="Signature Required"
      />
      <CompletedPopup />
    </div>
  );
}

